import { render, staticRenderFns } from "./imgClassification.vue?vue&type=template&id=463c081c"
import script from "./imgClassification.vue?vue&type=script&lang=js"
export * from "./imgClassification.vue?vue&type=script&lang=js"
import style0 from "./imgClassification.vue?vue&type=style&index=0&id=463c081c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports